"use client";
import styled from "styled-components";
import InnerBanner from "@/components/InnerBanner";

import ServiceOverview from "@/components/service/ServiceOverview";
import ServiceMenu from "@/components/service/ServiceMenu";
import ServiceZigzag from "@/components/service/ServiceZigzag";
import Footer from "@/components/Footer";
import {useEffect} from "react";


const AllAbout = ({data}) => {
    const getServiceData = data;
    const banner = getServiceData?.data?.sections?.find(f=>f?.section_data?.template === 'inner_banner');
    const service_overview = getServiceData?.data?.sections?.find(f=>f?.section_data?.template === 'service_overview');
    const service_list = getServiceData?.data?.sections?.find(f=>f?.section_data?.template === 'service_post_list');

    useEffect(() => {
        window.scroll(0, 10);
    }, []);

    return (
        <StyledComponent>

            <InnerBanner
                text={banner?.section_data?.subtitle}
                img={banner?.images?.list?.[0]?.full_path}
            />
            <ServiceOverview upper_text={'Investment'}
                             lower_text={'Banking'}
                             section_title={service_overview?.section_data?.section_title}
                             subtitle={service_overview?.section_data?.short_desc}
                             desc={service_overview?.section_data?.description}
            />
            <ServiceMenu data={service_list?.posts?.list}/>
            {
                service_list?.posts?.list && service_list?.posts?.list.length > 0 &&
                service_list?.posts?.list.map((item, index) => {
                    const isLastItem = index === service_list.posts.list.length - 1;
                    const paddingClass = `pt-100 ${isLastItem ? 'pb-100' : ''}`;
                    const reverse = index % 2 === 0 ? 'yes' : 'no';
                    const thumbImages = item?.images?.find(image => image.thumb === "on");
                    const svgImages = item?.images?.filter(image => image.svg === "on");

                    return (
                        <ServiceZigzag
                            key={index}
                            title={item?.data?.subtitle}
                            img={thumbImages?.full_path}
                            pdTop={paddingClass}
                            desc={item?.data?.description}
                            reverse={reverse}
                            sectionId={`section${index + 1}`}
                            listing={svgImages}
                        />
                    );
                })
            }

        </StyledComponent>
    );
};


const StyledComponent = styled.section`

`;

export default AllAbout;